export default [
  //Desk
  {
    name: 'desk',
    type: 'gltfModel',
    path: '/models/desk2.glb',
  },
  {
    name: 'bakedDesk',
    type: 'texture',
    path: '/models/desk-baked.jpg',
  },
  {
    name: 'macScreen',
    type: 'texture',
    path: '/mac-day.jpg',
  },
  //Sofa
  {
    name: 'sofa',
    type: 'gltfModel',
    path: '/models/salon.glb',
  },
  {
    name: 'bakedSofa',
    type: 'texture',
    path: '/models/sofa.jpg',
  },
  {
    name: 'bakedTable',
    type: 'texture',
    path: '/models/table.jpg',
  },
  {
    name: 'bakedRug',
    type: 'texture',
    path: '/models/rug.jpg',
  },
  {
    name: 'uxImage',
    type: 'texture',
    path: '/models/ux.jpg',
  },
  //TV
  {
    name: 'tv',
    type: 'gltfModel',
    path: '/models/tv.glb',
  },
  {
    name: 'tvTexture',
    type: 'texture',
    path: '/models/tv.jpg',
  },
  {
    name: 'screenTexture',
    type: 'texture',
    path: '/models/screen.png',
  },
]
